import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useQuery from "../../Component/devDashboard2/common/useQuery";
import { AuthContext } from "../../context/auth-context";
import {
  fetchCustomerLlms,
  getMarkets,
  getGeographies,
  getLlms,
  getCompMetricsForBrand,
  getCompMetricsForProduct,
  getCustomerMonitoringFiletrs,
} from "../../services/apiService";
import { fetchBrands } from "../../redux/actions/brandsActions";
import { fetchBrandProducts } from "../../redux/actions/brandProductsActions";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import EmptyView from "../../Component/EmptyView/EmptyView";
import classes from "./MetricContent.module.css";
import {
  calculateAverageData,
  calculateAverageDataStructure,
  getCompetitorMetricData,
  handleInputValidation,
  transformProductDimensions,
} from "../../utils/monitoring-helpers";
import DashboardNav from "./Form";
import api from "../../BrandOnBoarding/api";
import { useRef } from "react";
import GenericTable from "../../Component/BuyingJourneyDataTable/GenericTable";
import {
  getUniqueAttributes,
  sanitizeObject,
  splitDataObjByDayAndMonth,
  transformDriverData,
  transformFunnelData,
} from "../../utils/helpers";
import History from "./History/History";
import useHistory from "./History/useHistory";
import FocusAreas from "./FocusAreas/FocusAreas";
import {
  getNonEmptyKeys,
  prepareFocusAreaOutput,
  transformFocusArea,
} from "../../utils/metric-content-helpers";
import { Button, Card, Typography } from "@mui/material";
import BuyingJourneyDataTable from "../../Component/BuyingJourneyDataTable/DataTable";
import MUIButton from "../../Component/UI/MUIButton/MUIButton";
import ContentMapAnalysis from "../../Component/BuyingJourneyDataTable/ContentMapAnalysis";
import { useDailyLimits } from "../../hooks/useDailyLimits";
import Header from "../../Component/Header/Header";
import Share from "./Share/Share";
import MetricContentPDFExport from "./PDFExport/MetricContentPDFExport";
import { dynamicReplace } from "../Dashboard/Component/ActionComponent/ActionModal";
import { ENTITY_LABELS } from "../../utils/labelMapping";

const CONTENT_TYPES = [
  { id: 1, name: "Reach" },
  { id: 1, name: "Sentiment" },
];

const MetricContentMapping = (props) => {

  const {
    launchText,
    hoverText,
    updateLaunches,
    launchesRemaining,
    isSpecial,
    frequency: launchLimitFrequency,
  } = useDailyLimits("ContentMapping");

  const [selectedOptionShow, setSelectedOptionShow] = useState("Company/Brand");
  const [currentHistoryId, setCurrentHistoryId] = useState(null);
  const [currentEntity, setCurrentEntity] = useState("");
  const [isSharedView, setIsSharedView] = useState(false);
  const value = 0;

  const [showData, setShowData] = useState(false);
  const [isDone, setIsDone] = useState(true);
  const [selectedLlmItems, setSelectedLlmItems] = useState([]);
  const [selectedContentMapLlmItems, setSelectedContentMapLlmItems] = useState(
    ['Claude4']
  );
  const [selectedContentMapAnalysisLlmItems, setSelectedContentMapAnalysisLlmItems] = useState(
    []
  );
  const [contentMapLlm, setContentMapLlm] = useState('Claude4');
  const [contentMapAnalysisLlm, setContentMapAnalysisLlm] = useState();
  const [selectedMarketItems, setSelectedMarketItems] = useState([]);
  const [selectedGeographyItems, setSelectedGeographyItems] = useState([]);
  const [dbLlms, setDbLlms] = useState([]);
  const selectedFrequencyItems = ["Daily"];

  const [brandItems, setBrandItems] = useState([]);
  const [productItems, setProductItems] = useState([]);
  const [selectedBrandItems, setSelectedBrandItems] = useState([]);
  const [selectedProductItems, setSelectedProductItems] = useState([]);

  const [personas, setPersonas] = useState([]);
  const [selectedPersona, setSelectedPersona] = useState([]);

  const [customerLlm, setCustomerLlm] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [geography, setGeography] = useState([]);

  const [selectedInputIds, setSelectedInputIds] = useState();

  const [focusAreaInputs, setFocusAreaInputs] = useState(null);
  const [currentCategory, setCurrentCategory] = useState("");
  const [contentMapData, setContentMapData] = useState([]);
  const [contentMapAnalysisData, setContentMapAnalysisData] = useState([]);
  const [monitoringFiletrs, setMonitoringFilters] = useState();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState(null);

  const query = useQuery();
  const { id: historyId } = useParams();
  const navigate = useNavigate();

  const frequency = query.get("dateRange");

  const [selectedSubFrequencyItems, setSelectedSubFrequencyItems] = useState(
    frequency || "Current"
  );

  const dispatch = useDispatch();
  const brandProducts = useSelector((state) => state.brandProducts);
  const brands = useSelector((state) => state.brands);

  const { user, authUserEmail } = useContext(AuthContext);

  const { addHistory, updateHistory } = useHistory(authUserEmail);

  const customerId = user?.customer_id || 0;
  const isDemoAvailable = !!user?.is_demo_available;
  const [demoMode, setDemoMode] = useState(
    () => sessionStorage.getItem("contentMapDemoMode") === "true"
  );
  const effectiveEmail = demoMode ? "demo@yopmail.com" : authUserEmail;
  const effectiveCustomerId = demoMode ? 27 : customerId;

  const handleDemoModeChange = (checked) => {
    sessionStorage.setItem("contentMapDemoMode", String(checked));
    window.location.reload();
  };

  const isMonitoringEmpty = !demoMode && monitoringFiletrs !== undefined && !(monitoringFiletrs?.brands?.length > 0);

  // content data apis and states

  const [discussionTopics, setDiscussionTopics] = useState(null);

  const [discussionTopicsLoading, setDiscussionTopicsLoading] = useState(false);
  const [contentMapLoading, setContentMapLoading] = useState(false);
  const [contentMapAnalysisLoading, setContentMapAnalysisLoading] = useState(false);
  const [childKey, setChildKey] = useState(0);

  const remountChild = () => {
    setChildKey((prev) => prev + 1);
  };

  const [error, setError] = useState();

  const discussionTopicsAbortCtrRef = useRef(null);

  const handleContentMapAnalysisData = async () => {

    if (!contentMapAnalysisLlm) {
      toast.warn("No LLM selected!");
      return;
    }

    try {
      const payload = {
        content_mapping: contentMapData?.data || '',
        llm: contentMapAnalysisLlm || "",

      };
      setContentMapAnalysisLoading(true);
      const response = await api.post(
        "/metrics/generate-metric-content-analysis",
        payload
      );
      setContentMapAnalysisData(response?.data)
      const entity = selectedProductItems?.[0] || selectedBrandItems?.[0];
      const type = selectedOptionShow === "Product" ? "product" : "brand";
      const category = currentCategory;

      const dataForHistory = {
        entity,
        type,
        category,
        data: contentMapData,
        focusAreaInputs,
        discussionTopics,
        contentAnalysisData: response?.data,
        persona: selectedPersona?.[0],
        location: selectedGeographyItems?.[0],
        market: selectedMarketItems?.[0]
      };

      const sanitizedData = sanitizeObject(dataForHistory);

      // Update existing history if we have a history ID, otherwise create new
      if (currentHistoryId) {
        await updateHistory(
          currentHistoryId,
          `${entity} ${type} Overview`,
          sanitizedData
        );
      } else {
        const historyResponse = await addHistory({
          user_email: authUserEmail,
          name: `${entity} ${type} Overview`,
          date: Date.now(),
          category,
          type,
          entity,
          is_purchase_journey: false,
          is_conversations: false,
          json_data: sanitizedData,
        });

        // Set current history ID and entity for sharing
        if (historyResponse?.data?.id) {
          setCurrentHistoryId(historyResponse.data.id);
          setCurrentEntity(entity || "");
        }
      }

    } catch (err) {
      console.log('err===>', err)
    } finally {
      setContentMapAnalysisLoading(false);
      remountChild();
    }

  }

  const handleContentMapping = async () => {
    const data = transformFocusArea(focusAreaInputs, selectedOptionShow);
    const selectedFocusAreaInputs = getNonEmptyKeys(data);

    if (
      !selectedFocusAreaInputs ||
      selectedFocusAreaInputs.length === 0

    ) {
      toast.warn("No focus area selected!");
      return;
    } else if (discussionTopics === null) {
      toast.warn("No discussion topics data available!");
      return;
    }

    const luminaire_inputs = {};
    const promptResults = {};
    for (const [key, value] of Object.entries(data)) {
      if (Array.isArray(value) && value.length > 0) {
        luminaire_inputs[key] = value;
      }
    }

    const requiredKeys = ["Reach", "Purchase_Criteria"];
    const requiredBrandMetricKeys = [
      "Negative_Attributes",
      "Positive_Attributes",
      "Brand_Pillars",
      "Product_Dimensions",
      "Negative_Sentiment_Drivers",
      "Positive_Sentiment_Drivers",
    ];
    const isCategoryData = requiredKeys.some((str) =>
      selectedFocusAreaInputs.includes(str)
    );
    const isBrandData = requiredBrandMetricKeys.some((str) =>
      selectedFocusAreaInputs.includes(str)
    );
    if (isCategoryData) {
      promptResults.category_discussion_topics =
        discussionTopics?.discussionTopics?.discussion_topics;
      promptResults.category_purchase_barriers =
        discussionTopics?.purchaseBarriers?.category_data;
      promptResults.category_purchase_enablers =
        discussionTopics?.purchaseEnablers?.category_data;
      promptResults.category_purchase_jounrey_questions =
        discussionTopics?.purchaseJourneyQuestions?.category_questions?.questions_by_funnel_stage;
    }

    if (isBrandData) {
      promptResults.brand_discussion_topics =
        discussionTopics?.discussionTopics?.entity_discussion_topics;
      promptResults.brand_purchase_barriers =
        discussionTopics?.purchaseBarriers?.entity_data;
      promptResults.brand_purchase_enablers =
        discussionTopics?.purchaseEnablers?.entity_data;
      promptResults.brand_purchase_jounrey_questions =
        discussionTopics?.purchaseJourneyQuestions?.entity_questions?.questions_by_funnel_stage;
    }

    try {
      if (Object.keys(luminaire_inputs).length === 0) return;
      const payload = {
        entity: selectedProductItems?.[0] || selectedBrandItems?.[0],
        type: selectedOptionShow === "Product" ? "product" : "brand",
        category: currentCategory,
        location: selectedGeographyItems?.[0] || "",
        persona: selectedPersona?.[0] || "",
        llm: "Claude4",
        luminaire_inputs,
        promptResults,
      };
      setContentMapLoading(true);

      const response = await api.post(
        "/metrics/generate-metric-content",
        payload
      );
      const transformedResponse = {
        ...response?.data,
        data: response?.data?.data?.map(item => ({
          ...item,
          type: item.type.replace("Reach", ENTITY_LABELS.rank),
          theme: item.theme.replace("Reach", ENTITY_LABELS.rank)
        })),
        filterKeys: response?.data?.filterKeys?.map(key => ({
          ...key,
          name: key.name.replace("Reach", ENTITY_LABELS.rank),
          value: key.value.replace("Reach", ENTITY_LABELS.rank)
        }))
      };
      setContentMapData(transformedResponse);

      if (launchesRemaining == 0 && !isSpecial) {
        toast.warn(
          `You have reached your ${launchLimitFrequency} limit`
        );
        return;
      }
      if (!isSpecial) updateLaunches();

      // Save to history and capture the history ID
      const entity = selectedProductItems?.[0] || selectedBrandItems?.[0];
      const type = selectedOptionShow === "Product" ? "product" : "brand";
      const category = currentCategory;

      const dataForHistory = {
        entity,
        type,
        category,
        data: transformedResponse,
        focusAreaInputs,
        discussionTopics,
        persona: selectedPersona?.[0],
        location: selectedGeographyItems?.[0],
        market: selectedMarketItems?.[0]
      };

      const sanitizedData = sanitizeObject(dataForHistory);
      const historyResponse = await addHistory({
        user_email: authUserEmail,
        name: `${entity} ${type} Overview`,
        date: Date.now(),
        category,
        type,
        entity,
        is_purchase_journey: false,
        is_conversations: false,
        json_data: sanitizedData,
      });

      console.log('historyResponse==>', historyResponse)

      // Set current history ID and entity for sharing
      if (historyResponse?.data?.id) {
        setCurrentHistoryId(historyResponse.data.id);
        setCurrentEntity(entity || "");
      }

      setContentMapLoading(false);
    } catch (err) {
      setContentMapLoading(false);
    } finally {
      remountChild();
    }
  };




  async function getContentMappingData(
    entity,
    category,
    purchase_criterias,
    brand_pillars,
    product_taxonomies,
    negative_attributes,
    positive_attributes,
    indexScoreMeta,
    purchase_criteriasV2,
    brand_pillarsV2,
    reach
  ) {
    let sentiment_drivers;
    let positive_sentiment_drivers;

    if (indexScoreMeta && indexScoreMeta.length > 0) {
      if (
        indexScoreMeta?.[0]?.sentiment_json_response?.extras
          ?.sentiementKeyDrivers
      ) {
        sentiment_drivers =
          indexScoreMeta?.[0]?.sentiment_json_response?.extras
            ?.sentiementKeyDrivers?.negative;

        positive_sentiment_drivers =
          indexScoreMeta?.[0]?.sentiment_json_response?.extras
            ?.sentiementKeyDrivers?.positive;
      } else {
        const payload = {
          sentimentMeta:
            indexScoreMeta?.[0]?.sentiment_json_response?.extras?.sentimentMeta,
        };
        const response = await api.post("/metrics/sentiment-drivers", payload);
        sentiment_drivers = response.data?.negative;
        positive_sentiment_drivers = response.data?.positive;
      }
    }

    const focusAreaIdentifications = prepareFocusAreaOutput(
      {
        reach,
        sentimentDrivers: sentiment_drivers,
        positiveSentimentDrivers: positive_sentiment_drivers,
        brand_pillars: brand_pillarsV2,
        purchase_criteria: purchase_criteriasV2,
        positiveAttributesInput: positive_attributes,
        negativeAttributesInput: negative_attributes,
      },
      selectedOptionShow
    );

    setFocusAreaInputs(focusAreaIdentifications);
  }



  useEffect(() => {
    // Skip this effect if in shared view mode or if loading from URL
    if (isSharedView || historyId) return;

    async function fetchData() {
      const selectedBrandCustomerId =
        query.get("brandCustomerId") || customerId;
      const customerSpecificLlms = await fetchCustomerLlms([
        Number(selectedBrandCustomerId),
      ]);

      setCustomerLlm(customerSpecificLlms?.data);
      const inputFilters = await getCustomerMonitoringFiletrs(effectiveCustomerId);

      // Deep copy to avoid mutation if needed (e.g., structuredClone or JSON approach)
      let filters = {
        ...inputFilters,
        brands: [...(inputFilters?.brands || [])],
        products: [...(inputFilters?.products || [])],
      };

      setMonitoringFilters(filters);

      if (selectedOptionShow === "Company/Brand") {
        const llms = filters?.brands?.[0]?.categories?.[0]?.llms;

        let llmFromQuery = llms?.[0]?.name;

        const markets = filters?.brands?.[0]?.categories?.[0]?.markets;
        let marketFromQuery = markets?.[0]?.name;

        const geography = filters?.brands?.[0]?.categories?.[0]?.geographies;

        let geoFromQuery = geography?.[0]?.name;

        const persona = filters?.brands?.[0]?.categories?.[0]?.personas;
        const category = filters?.brands?.[0]?.categories?.map((item) => {
          return { id: item?.categoryId, name: item?.categoryName };
        });

        const categoryIds = [category?.[0]?.id] || null;

        setDbLlms(llms);
        setMarkets(markets);
        setGeography(geography);

        setSelectedBrandItems([filters?.brands?.[0]?.brand_name]);
        setSelectedPersona([persona?.[0]?.name]);
        setSelectedLlmItems([llmFromQuery]);
        setSelectedMarketItems([marketFromQuery]);
        setSelectedGeographyItems([geoFromQuery]);
        setBrandItems(
          filters?.brands?.map((item) => {
            return { id: item?.customer_brand_id, name: item?.brand_name };
          })
        );
        setPersonas(persona);
        setCategories(category);
        setSelectedCategory([category?.[0]?.name]);
        setSelectedCategoryIds(categoryIds);
      }

      if (selectedOptionShow === "Product") {
        console.log("test==>", filters);
        const geography = filters?.products?.[0]?.categories?.[0]?.geographies;
        const markets = filters?.products?.[0]?.categories?.[0]?.markets;
        const persona = filters?.products?.[0]?.categories?.[0]?.personas;
        const llms = filters?.products?.[0]?.categories?.[0]?.llms;
        const category = filters?.products?.[0]?.categories?.map((item) => {
          return { id: item?.categoryId, name: item?.categoryName };
        });
        const categoryIds = [category?.[0]?.id] || null;

        setDbLlms(llms);
        setGeography(geography);
        setMarkets(markets);
        setSelectedProductItems([filters?.products?.[0]?.product_name]);
        setSelectedPersona([persona?.[0]?.name]);
        setSelectedLlmItems([llms?.[0]?.name]);
        setSelectedMarketItems([markets?.[0]?.name]);
        setSelectedGeographyItems([geography?.[0]?.name]);
        setProductItems(
          filters?.products?.map((item) => {
            return {
              id: item?.customer_brand_product_id,
              name: item?.product_name,
            };
          })
        );
        setPersonas(persona);
        setCategories(category);
        setSelectedCategory([category?.[0]?.name]);
        setSelectedCategoryIds(categoryIds);
      }

      const category = selectedOptionShow === 'Product' ? filters?.products?.[0]?.categories?.map((item) => {
        return { id: item?.categoryId, name: item?.categoryName };
      })?.[0]?.name : filters?.brands?.[0]?.categories?.map((item) => {
        return { id: item?.categoryId, name: item?.categoryName };
      })?.[0]?.name

      const entity = selectedOptionShow !== 'Product' ? filters?.brands?.[0]?.brand_name : filters?.products?.[0]?.product_name

      const response = await api.get(
        `/users/conversation-history?user_email=${encodeURIComponent(effectiveEmail)}
        &entity=${entity}&category=${category}
        &type=${selectedOptionShow === "Product" ? "product" : "brand"}&is_conversations=true`,
      );
      setDiscussionTopics(response?.data?.data?.[0]?.json_data?.discussionTopics || null)
    }

    fetchData();
  }, [selectedOptionShow, isSharedView, historyId]);

  useEffect(() => {
    // Skip this effect if in shared view mode or if loading from URL
    if (isSharedView || historyId) return;

    async function fetchCustomerLlmsData() {
      if (selectedProductItems && selectedProductItems.length > 0) {
        if (selectedOptionShow === "Product") {
          const geography = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.geographies;
          const markets = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.markets;
          const persona = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.personas;
          const llms = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.llms;
          const category = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems?.includes(item?.product_name)
            )?.[0]
            ?.categories?.map((item) => {
              return { id: item?.categoryId, name: item?.categoryName };
            });
          const categoryIds = [category?.[0]?.id] || null;
          setSelectedCategoryIds(categoryIds);
          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
          setCategories(category);
          setSelectedLlmItems([llms?.[0]?.name]);
          setSelectedMarketItems([markets?.[0]?.name]);
          setSelectedGeographyItems([geography?.[0]?.name]);
          setSelectedPersona([persona?.[0]?.name]);
          setSelectedCategory([category?.[0]?.name]);
        }
      }
    }

    fetchCustomerLlmsData();
  }, [selectedProductItems, isSharedView, historyId]);

  useEffect(() => {
    // Skip this effect if in shared view mode or if loading from URL
    if (isSharedView || historyId) return;

    async function fetchCustomerLlmsData() {
      if (selectedBrandItems && selectedBrandItems.length > 0) {
        if (selectedOptionShow === "Company/Brand") {
          const geography = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.geographies;
          const markets = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.markets;
          const persona = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.personas;
          const llms = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.llms;
          const category = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems?.includes(item?.brand_name)
            )?.[0]
            ?.categories?.map((item) => {
              return { id: item?.categoryId, name: item?.categoryName };
            });
          const categoryIds = [category?.[0]?.id] || null;
          setSelectedCategoryIds(categoryIds);

          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
          setCategories(category);
          setSelectedLlmItems([llms?.[0]?.name]);
          setSelectedMarketItems([markets?.[0]?.name]);
          setSelectedGeographyItems([geography?.[0]?.name]);
          setSelectedPersona([persona?.[0]?.name]);
          setSelectedCategory([category?.[0]?.name]);
        }
      }
    }

    fetchCustomerLlmsData();
  }, [selectedBrandItems, isSharedView, historyId]);

  useEffect(() => {
    // Skip this effect if in shared view mode or if loading from URL
    if (isSharedView || historyId) return;

    async function fetchData() {
      const entity = selectedOptionShow === 'Product' ? selectedProductItems?.[0] : selectedBrandItems?.[0]

      const response = await api.get(
        `/users/conversation-history?user_email=${encodeURIComponent(effectiveEmail)}
        &entity=${entity}&category=${selectedCategory?.[0] || ""}
        &type=${selectedOptionShow === "Product" ? "product" : "brand"}&is_conversations=true`,
      );
      setDiscussionTopics(response?.data?.data?.[0]?.json_data?.discussionTopics || null)
    }

    setTimeout(() => {
      fetchData()
    }, 400)

  }, [selectedBrandItems, selectedCategory, selectedProductItems, isSharedView, historyId]);

  useEffect(() => {
    // Skip this effect if in shared view mode or if loading from URL
    if (isSharedView || historyId) return;

    async function fetchCustomerLlmsData() {
      if (selectedCategory && selectedCategory.length > 0) {
        if (
          selectedProductItems?.length !== 0 &&
          selectedOptionShow === "Product"
        ) {
          const geography = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.geographies;
          const markets = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.markets;
          const persona = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.personas;
          const llms = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.llms;

          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
        }

        if (
          selectedBrandItems?.length !== 0 &&
          selectedOptionShow === "Company/Brand"
        ) {
          const geography = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.geographies;
          const markets = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.markets;
          const persona = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.personas;
          const llms = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.llms;

          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
        }
      }
    }

    fetchCustomerLlmsData();
  }, [selectedCategory, isSharedView, historyId]);

  // Load history item from URL parameter
  useEffect(() => {
    async function loadHistoryFromUrl() {
      if (historyId) {
        try {
          // Set shared view FIRST before loading data
          setIsSharedView(true);
          const response = await api.get(`/users/content-map-history/${historyId}`);
          if (response?.data?.data) {
            updateStatesFromHistory(response.data?.data, false);
          }
        } catch (error) {
          console.error("Error loading history:", error);
          toast.error("Failed to load shared content mapping.");
        }
      }
    }

    loadHistoryFromUrl();
  }, [historyId]);

  const handleLlmCheckChange = (selected) => {
    const selectedValues = selected?.map((option) => option?.name) || [];

    setSelectedLlmItems(selectedValues.at(-1) ? [selectedValues.at(-1)] : []);
  };

  const handleCategoryCheckChange = (selected) => {
    if (!selected || selected.length === 0) {
      setSelectedCategory([]);
      setSelectedCategoryIds([]);
      return;
    }

    const lastSelected = selected[selected.length - 1];
    setSelectedCategory([lastSelected.name]);
    setSelectedCategoryIds([lastSelected.id]);
  };

  const handleContentMapLlmCheckChange = (selected) => {
    const selectedValues = selected?.map((option) => option?.name) || [];
    const selectedLlms = selected?.map((option) => option?.value) || [];
    setSelectedContentMapLlmItems(
      selectedValues.at(-1) ? [selectedValues.at(-1)] : []
    );
    setContentMapLlm(selectedLlms.at(-1));
  };

  const handleContentMapAnalysisLlmCheckChange = (selected) => {
    const selectedValues = selected?.map((option) => option?.name) || [];
    const selectedLlms = selected?.map((option) => option?.value) || [];
    setSelectedContentMapAnalysisLlmItems(
      selectedValues.at(-1) ? [selectedValues.at(-1)] : []
    );
    setContentMapAnalysisLlm(selectedLlms.at(-1));
  };

  const handlesubFrequencyCheckChange = (key) => {
    setSelectedSubFrequencyItems(key);
  };

  const handleMarketCheckChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );

    setSelectedMarketItems(selectedValues || []);
  };

  const handleGeographyCheckChange = async (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    const latestValue = selectedValues[selectedValues.length - 1];
    setSelectedGeographyItems(selectedValues || []);

    let geoId = geography.filter((obj) => obj?.name === latestValue)[0]?.id;
    let market = await getMarkets();
    const filtercustomeLlm = customerLlm.filter(
      (obj) => obj?.geography_id === geoId
    );

    if (selectedValues && selectedValues.length === 1) {
      // set customer geography markets

      const marketIds = [
        ...new Set(filtercustomeLlm.map((obj) => obj?.market_id)),
      ];
      market = market?.data.filter((obj) => marketIds.includes(obj?.id));
      setMarkets(market);
    } else if (selectedValues && selectedValues.length > 1) {
      // set customer geography markets

      market = market?.data.filter((obj) => obj?.name === "General Market");
      setMarkets(market);
    }
  };

  const handleProductCheckChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );

    setSelectedProductItems(selectedValues || []);
  };

  const handleBrandCheckChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );

    setSelectedBrandItems(selectedValues || []);
  };

  const handlePersonaCheckChange = (selected) => {
    const selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    const lastSelectedValue = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    setSelectedPersona(lastSelectedValue || []);
  };

  const getInputIds = () => {
    const brandId =
      brandItems.filter((item) => item?.name === selectedBrandItems[0])[0]
        ?.id || null;

    const productId =
      productItems.filter((item) => item?.name === selectedProductItems[0])[0]
        ?.id || null;

    const brandIds = brandItems
      .filter((item) => selectedBrandItems.includes(item?.name))
      .map((obj) => obj?.id);

    const productIds = productItems
      .filter((item) => selectedProductItems.includes(item?.name))
      .map((obj) => obj?.id);

    const globalLlmId = dbLlms.filter(
      (item) => item?.name === selectedLlmItems[0]
    )[0]?.id;
    const marketId = markets.filter(
      (item) => item?.name === selectedMarketItems[0]
    )[0]?.id;

    const geoId = geography.filter(
      (item) => item?.name === selectedGeographyItems[0]
    )[0]?.id;

    const llmId = customerLlm.filter(
      (item) =>
        item?.llm_id === globalLlmId &&
        item?.market_id === marketId &&
        item?.geography_id === geoId
    )[0]?.id;
    const personaId = personas
      .filter((item) => selectedPersona.includes(item?.name))
      .map((obj) => obj?.id);

    return {
      brandId,
      brandIds,
      productId,
      productIds,
      globalLlmId,
      llmId,
      personaId,
    };
  };

  const handleClickShow = async () => {
    const error = handleInputValidation(
      selectedOptionShow,
      selectedBrandItems,
      selectedProductItems,
      selectedPersona,
      selectedFrequencyItems,
      value,
      selectedSubFrequencyItems,
      selectedLlmItems,
      selectedGeographyItems,
      selectedMarketItems
    );

    if (error) {
      toast.warn(error, {
        autoClose: 700,
      });
      return;
    }

    setContentMapData([]);
    setFocusAreaInputs(null);
    const { brandId, brandIds, productId, productIds, llmId, personaId } =
      getInputIds();

    await getCompDashboardDataFromDB(
      brandId,
      productId,
      llmId,
      personaId,
      false,
      undefined,
      undefined,
      undefined,
      brandIds,
      productIds
    );
  };

  const getCustomerLlmInputIds = () => {
    const llmIds = dbLlms
      .filter((item) => selectedLlmItems.includes(item?.name))
      .map((obj) => obj?.id);

    const marketIds = markets
      .filter((item) => selectedMarketItems.includes(item?.name))
      .map((obj) => obj?.id);

    const geoIds = geography
      .filter((item) => selectedGeographyItems.includes(item?.name))
      .map((obj) => obj?.id);

    const customerLlmIds = customerLlm
      .filter(
        (item) =>
          llmIds.includes(item?.llm_id) &&
          marketIds.includes(item?.market_id) &&
          geoIds.includes(item?.geography_id)
      )
      .map((obj) => obj?.id);

    return customerLlmIds;
  };

  const getCompetitorComparisonData = async (
    brandId,
    productId,
    personaId,
    llmId,
    isInitial,
    brandName,
    productName,
    categoryName,
    brandIds,
    productIds
  ) => {
    let result;

    const customerLlmIds = getCustomerLlmInputIds();
    setSelectedInputIds({
      brandId,
      productId,
      personaId,
      llmIds: customerLlmIds.length === 0 ? [llmId] : customerLlmIds,
    });

    if (selectedOptionShow === "Company/Brand") {
      const payload = {
        brandId: brandId,
        llmId: llmId,
        brandIds: brandIds,
        llmIds: customerLlmIds.length === 0 ? [llmId] : customerLlmIds,
        personaIds: personaId,
        categoryIds: selectedCategoryIds,
        frequency: selectedFrequencyItems[0],
        timePeriod: selectedSubFrequencyItems,
      };

      result = await getCompMetricsForBrand(payload);
    } else {
      const payload = {
        productId: productId,
        llmId: llmId,
        llmIds: customerLlmIds.length === 0 ? [llmId] : customerLlmIds,
        personaIds: personaId,
        productIds: productIds,
        categoryIds: selectedCategoryIds,
        frequency: selectedFrequencyItems[0],
        timePeriod: selectedSubFrequencyItems,
      };

      result = await getCompMetricsForProduct(payload);
    }

    const {
      data,
      categoryDimdata,
      attributesData,
      selectedBrandCategory,
      selectedBrandProductCategory,
    } = getCompetitorMetricData(
      result,
      selectedOptionShow,
      selectedBrandItems,
      selectedProductItems,
      brandName,
      productName,
      selectedSubFrequencyItems,
      brands,
      brandProducts
    );

    const { realPastDate } = result;

    const { filteredData } = splitDataObjByDayAndMonth(
      realPastDate?.day,
      realPastDate?.month,
      realPastDate?.year,
      result?.brandIndexcumulativeData,
      true
    );

    const reach = filteredData?.brand?.map((item) => {
      return {
        text: `${ENTITY_LABELS.rank} score stands at ${Number(
          item?.avg_brand_reach_score
        ).toFixed(0)}`,
      };
    });

    const positiveAtt = calculateAverageData(attributesData?.mergedData)?.[
      "avg"
    ];
    const negativeAtt = calculateAverageData(
      attributesData?.negativeAttributesMergedData
    )?.["avg"];

    const brand_pillars = Object.entries(
      calculateAverageDataStructure?.(data)?.avg?.[selectedBrandItems?.[0]] ||
      {}
    )
      .filter(([_, value]) => value?.avgValue <= 6)
      .map(([key]) => key);

    const productDimensions = transformProductDimensions(
      result?.productTaxonomyData,
      selectedProductItems?.[0]
    );

    const core_attributes = Object.entries(
      calculateAverageDataStructure?.(data)?.avg?.[selectedBrandItems?.[0]] ||
      {}
    )?.map(([key, value]) => {
      return { name: key, score: value?.avgValue };
    });

    const brand_pillarsV2 =
      selectedOptionShow !== "Product" ? core_attributes : productDimensions;

    const entity =
      selectedOptionShow === "Product"
        ? selectedProductItems?.[0]
        : selectedBrandItems?.[0];

    const category = selectedCategory?.[0];

    const purchase_criterias = Object.entries(
      calculateAverageDataStructure?.(categoryDimdata)?.avg?.[entity] || {}
    )
      .filter(([_, value]) => value?.avgValue <= 10)
      .map(([key]) => key);

    const purchase_criteriasV2 = Object.entries(
      calculateAverageDataStructure?.(categoryDimdata)?.avg?.[entity] || {}
    )?.map(([key, value]) => {
      return { name: key, score: value?.avgValue };
    });

    const positive_attributes = getUniqueAttributes(positiveAtt, entity)?.slice(
      0,
      10
    );
    const negative_attributes = getUniqueAttributes(negativeAtt, entity)?.slice(
      0,
      10
    );

    const product_taxonomies = result?.productTaxonomyData?.map(
      (obj) => obj?.name
    );

    setCurrentCategory(category);

    return {
      entity,
      purchase_criterias,
      brand_pillars,
      product_taxonomies,
      negative_attributes,
      positive_attributes,
      category,
      indexScoreMeta: result?.indeScoreMetaData,
      purchase_criteriasV2,
      brand_pillarsV2,
      reach,
    };
  };

  const getCompDashboardDataFromDB = async (
    brandId,
    productId,
    llmId,
    personaId,
    isInitial,
    brandName,
    productName,
    categoryName,
    brandIds,
    productIds
  ) => {
    setShowData(false);
    setIsDone(false);

    try {
      const {
        entity,
        purchase_criterias,
        brand_pillars,
        product_taxonomies,
        negative_attributes,
        positive_attributes,
        category,
        indexScoreMeta,
        purchase_criteriasV2,
        brand_pillarsV2,
        reach,
      } = await getCompetitorComparisonData(
        brandId,
        productId,
        personaId,
        llmId,
        isInitial,
        brandName,
        productName,
        categoryName,
        brandIds,
        productIds
      );
      await getContentMappingData(
        entity,
        category,
        purchase_criterias,
        brand_pillars,
        product_taxonomies,
        negative_attributes,
        positive_attributes,
        indexScoreMeta,
        purchase_criteriasV2,
        brand_pillarsV2,
        reach
      );
    } catch (err) {
    } finally {
      setShowData(true);
      setIsDone(true);
    }
  };

  const handleContentTypeChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );

    setShowData(false);
  };

  const updateStatesFromHistory = (data, isFromHistory) => {
    const isShared = !isFromHistory;
    // Don't set isSharedView here - it should already be set before calling this function

    setContentMapData(data?.json_data?.data);
    setContentMapAnalysisData(data?.json_data?.contentAnalysisData);
    setFocusAreaInputs(data?.json_data?.focusAreaInputs);
    setDiscussionTopics(data?.json_data?.discussionTopics);
    setShowData(true);
    setIsDone(true);

    // Set current history ID and entity for sharing
    setCurrentHistoryId(data?.id);
    setCurrentEntity(data?.entity || "");

    // Restore additional fields from history
    const { persona, location, market, type } = data?.json_data || {};

    // Restore entity type (brand or product)
    if (type === 'product') {
      setSelectedOptionShow('Product');
      if (data?.entity) {
        setSelectedProductItems([data.entity]);
        if (isShared) {
          setProductItems([{ id: null, name: data.entity }]);
        }
      }
    } else if (type === 'brand') {
      setSelectedOptionShow('Company/Brand');
      if (data?.entity) {
        setSelectedBrandItems([data.entity]);
        if (isShared) {
          setBrandItems([{ id: null, name: data.entity }]);
        }
      }
    }

    // For shared view, only populate fields if they exist in data
    // Otherwise keep them empty
    if (isShared) {
      if (persona) {
        setSelectedPersona([persona]);
        setPersonas([{ id: null, name: persona }]);
      } else {
        setSelectedPersona([]);
        setPersonas([]);
      }

      if (location) {
        setSelectedGeographyItems([location]);
        setGeography([{ id: null, name: location }]);
      } else {
        setSelectedGeographyItems([]);
        setGeography([]);
      }

      if (market) {
        setSelectedMarketItems([market]);
        setMarkets([{ id: null, name: market }]);
      } else {
        setSelectedMarketItems([]);
        setMarkets([]);
      }

      if (data?.category) {
        setSelectedCategory([data.category]);
        setCurrentCategory(data.category);
        setCategories([{ id: null, name: data.category }]);
      } else {
        setSelectedCategory([]);
        setCurrentCategory("");
        setCategories([]);
      }
    } else {
      if (persona) {
        setSelectedPersona([persona]);
      }

      if (location) {
        setSelectedGeographyItems([location]);
      }

      if (market) {
        setSelectedMarketItems([market]);
      }

      if (data?.category) {
        setSelectedCategory([data.category]);
        setCurrentCategory(data.category);
      }
    }
  };

  if (
    selectedOptionShow === "Product" &&
    brandProducts?.data?.data &&
    !brandProducts?.data?.data.length
  ) {
    return <EmptyView message="No Products Found" />;
  }

  const transformDiscussionData = (arr) => {
    if (!arr || arr.length === 0) return;
    return arr.map((obj) => {
      return {
        [obj?.Topic ? "Topic" : "Key Question"]: `${obj?.Topic || obj?.["Key Question"]
          }-${obj?.rating}`,
        explanation: obj?.explanation,
      };
    });
  };

  const TableWrapper = ({
    data,
    title,
    loading,
    error,
    minWidth = "99%",
    sources,
  }) => (
    <div style={{ flex: 1, minWidth }}>
      <GenericTable
        sources={sources}
        data={
          title === "Brand Buying Journey Prompts" ||
            title === "Category Buying Journey Prompts"
            ? data
            : transformDiscussionData(data)
        }
        loading={loading}
        title={title}
        error={error}
      />
    </div>
  );

  const handleStartNew = async () => {
    // Reset all states to initial values
    setIsSharedView(false);
    setContentMapData([]);
    setContentMapAnalysisData([]);
    setFocusAreaInputs(null);
    setDiscussionTopics(null);
    setShowData(false);
    setIsDone(true);
    setCurrentHistoryId(null);
    setCurrentEntity("");

    // Navigate to base URL (this changes historyId to undefined)
    navigate('/luminaire/metric-content');

    // Reset all form selections to trigger fresh data fetch
    // The useEffects will run automatically after historyId becomes undefined
    setSelectedBrandItems([]);
    setSelectedProductItems([]);
    setSelectedPersona([]);
    setSelectedGeographyItems([]);
    setSelectedMarketItems([]);
    setSelectedCategory([]);
    setCurrentCategory("");
    setSelectedCategoryIds(null);

    // Clear the options arrays - they'll be repopulated by useEffects
    setBrandItems([]);
    setProductItems([]);
    setPersonas([]);
    setGeography([]);
    setMarkets([]);
    setCategories([]);
    setDbLlms([]);
    setMonitoringFilters(null);

    // Reset to default view
    setSelectedOptionShow("Company/Brand");
  };

  // Prepare PDF export props with configuration and data
  const preparePDFExportProps = () => {
    // Prepare focus areas data - filter only selected items
    const focusAreasForPdf = {};
    if (focusAreaInputs) {
      Object.entries(focusAreaInputs).forEach(([key, items]) => {
        if (Array.isArray(items)) {
          // Filter items that have selected=true or have text/name properties
          const selectedItems = items.filter(
            (item) => item?.selected || item?.text || item?.name
          );
          if (selectedItems.length > 0) {
            focusAreasForPdf[key] = selectedItems;
          }
        }
      });
    }

    // Prepare table data - convert to array of objects if needed
    const tableDataForPdf = contentMapData?.data || [];

    // Extract filter keys properly - handle both string array and object array
    let filterKeysForPdf = [];
    if (contentMapData?.filterKeys) {
      if (Array.isArray(contentMapData.filterKeys)) {
        filterKeysForPdf = contentMapData.filterKeys.map((key) => {
          if (typeof key === 'string') {
            return key;
          } else if (typeof key === 'object' && key?.name) {
            return key.name;
          }
          return String(key);
        });
      }
    }

    return {
      entityName: selectedProductItems?.[0] || selectedBrandItems?.[0],
      category: selectedCategory?.[0],
      persona: selectedPersona?.[0],
      location: selectedGeographyItems?.[0],
      market: selectedMarketItems?.[0],
      llm: selectedLlmItems?.[0],
      focusAreas: focusAreasForPdf,
      tableData: tableDataForPdf,
      filterKeys: filterKeysForPdf,
      isDisabled: contentMapLoading || discussionTopicsLoading || isSharedView,
    };
  };

  return (
    <div className="bodycontent">
      <Header actionText={launchText} hoverText={hoverText} actionVariant="text" />
      <div className={classes.section_summary}>
        <div>
          <DashboardNav
            contentTypes={CONTENT_TYPES}
            handleContentTypeChange={handleContentTypeChange}
            selectedOptionShow={selectedOptionShow}
            brandItems={brandItems}
            categories={categories}
            handleCategoryCheckChange={handleCategoryCheckChange}
            selectedCategory={selectedCategory}
            selectedBrandItems={selectedBrandItems}
            handleBrandCheckChange={handleBrandCheckChange}
            handleProductCheckChange={handleProductCheckChange}
            selectedProductItems={selectedProductItems}
            productItems={productItems}
            selectedPersona={selectedPersona}
            handlePersonaCheckChange={handlePersonaCheckChange}
            personas={personas}
            selectedGeographyItems={selectedGeographyItems}
            handleGeographyCheckChange={handleGeographyCheckChange}
            geography={geography}
            selectedMarketItems={selectedMarketItems}
            handleMarketCheckChange={handleMarketCheckChange}
            markets={markets}
            selectedLlmItems={selectedLlmItems}
            handleLlmCheckChange={handleLlmCheckChange}
            dbLlms={dbLlms}
            selectedSubFrequencyItems={selectedSubFrequencyItems}
            handlesubFrequencyCheckChange={handlesubFrequencyCheckChange}
            showData={showData}
            isDone={isDone}
            handleClickShow={handleClickShow}
            setSelectedOptionShow={setSelectedOptionShow}
            isDisabled={isSharedView}
            isSharedView={isSharedView}
            onStartNew={handleStartNew}
            isDemoMode={demoMode}
            noMonitoringData={isMonitoringEmpty}
          />
        </div>

        <div className={` ${classes.history}`}>
          <History
            key={childKey}
            filter={selectedOptionShow === "Product" ? "product" : "brand"}
            updateStatesFromHistory={updateStatesFromHistory}
            isDemoAvailable={isDemoAvailable}
            demoMode={demoMode}
            onDemoModeChange={handleDemoModeChange}
          />
        </div>
      </div>

      <div>
        {!showData && !isDone && (
          <div
            style={{
              fontSize: "22px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
              //   fontWeight: "bold",
            }}
          >
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            &nbsp;
            {`Preparing Content Mapping Inputs, Please Wait...`}
          </div>
        )}
        {showData && isDone && (
          <>
            <br />

            <>
              <div>
                <FocusAreas
                  data={focusAreaInputs}
                  setData={setFocusAreaInputs}
                  // input={focusAreaInputs}
                  type={selectedOptionShow}
                />
              </div>
              <hr />
            </>


            <div style={{ marginBottom: "150px" }}>
              <BuyingJourneyDataTable
                data={contentMapData?.data}
                loading={contentMapLoading}
                  filterOptions={contentMapData?.filterKeys}
                // filterOptions={contentMapData?.filterKeys?.map((key) => {
                //   return { ...key, name: dynamicReplace(key?.name) }
                // })}
                isDisabled={contentMapLoading || discussionTopicsLoading || isSharedView || demoMode || isMonitoringEmpty}
                title={`Content Suggestions`}
                handleContentMapping={handleContentMapping}
                selectedContentMapLlmItems={selectedContentMapLlmItems}
                handleContentMapLlmCheckChange={handleContentMapLlmCheckChange}
                shareComponent={
                  currentHistoryId && !isSharedView ? (
                    <Share historyId={currentHistoryId} entityName={currentEntity} />
                  ) : null
                }
                isSharedView={isSharedView}
                pdfExportComponent={
                  showData && isDone ? (
                    <MetricContentPDFExport {...preparePDFExportProps()} />
                  ) : null
                }
              />
            </div>

            {/* {contentMapData?.data && !isSharedView && <div style={{ marginBottom: "150px" }}>
              <ContentMapAnalysis
                data={contentMapAnalysisData?.analysis}
                summary={contentMapAnalysisData?.summary}
                items={contentMapAnalysisData?.recommendedNextSteps}
                loading={contentMapAnalysisLoading}
                filterOptions={contentMapData?.filterKeys}
                isDisabled={contentMapAnalysisLoading || discussionTopicsLoading || isSharedView}
                title={`Content Map Coverage Analysis`}
                handleContentMapping={handleContentMapAnalysisData}
                selectedContentMapLlmItems={selectedContentMapAnalysisLlmItems}
                handleContentMapLlmCheckChange={handleContentMapAnalysisLlmCheckChange}
              />
            </div>} */}



          </>
        )}
      </div>

      <ToastContainer />
    </div>
  );
};

export default MetricContentMapping;